var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSetCoverPicture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.994,
    height: 12.434,
    viewBox: "0 0 14.994 12.434",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -43.85)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M275.367,124.809a.958.958,0,1,1-.958-.959A.96.96,0,0,1,275.367,124.809Z",
    transform: "translate(-265.468 -77.665)",
    fill: "#c6cad7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.106,50.8.619,56.284H11.593Zm3.453,2.215,3.272,3.272h1.725a.438.438,0,0,0,.438-.438V53.831L11.867,50.7Zm5-9.162H.438A.438.438,0,0,0,0,44.288V55.665l5.8-5.8a.438.438,0,0,1,.619,0L8.94,52.393l2.618-2.618a.438.438,0,0,1,.619,0l2.817,2.817v-8.3A.438.438,0,0,0,14.556,43.85ZM8.94,48.978a1.834,1.834,0,1,1,1.834-1.834A1.836,1.836,0,0,1,8.94,48.978Z",
    fill: "#c6cad7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetCoverPicture);
export default __webpack_public_path__ + "static/media/set-cover-picture.3f5d9d6b8a11a40b65112206940b2d8e.svg";
export { ForwardRef as ReactComponent };